package top.wcpe.allincore.layout.engine

/**
 * 布局模式。
 *
 * 当前支持五种语义;后续可扩展 `FLOW_WRAP / LIST / WATERFALL`,但本枚举保持最小集合。
 *
 * **STACK 语义说明**:父容器为相对定位坐标系,所有未显式声明 [PositionMode.ABSOLUTE]
 * 的子节点会在 IR 解释阶段被自动改为 `ABSOLUTE` + `x=0, y=0`,从而真正层叠在父原点。
 * 子节点之间通过显式 `x/y` 偏移和声明顺序决定堆叠位置。这是项目自有的"堆叠"语义,
 * 由 DSL 的 `stack { ... }` kind 声明触发。
 *
 * **ABSOLUTE 语义说明**:父容器是"绝对定位画布",所有未显式声明 [PositionMode.ABSOLUTE]
 * 的子节点会在 IR 解释阶段被自动改为 `ABSOLUTE`,但**不**补默认 `x=0, y=0`——
 * 用户没写 x/y 时保留 auto,与 STACK 的核心差异在此。由 DSL 的 `box { layout = "absolute" }`
 * 写法触发。这两种 mode 在 Taffy 那边都映射到 `Display::Flex`,通过子的 absolute 定位
 * 绕开 flex 流式算法,效果等价于 CSS `position:relative` 父 + `position:absolute` 子。
 */
enum class LayoutMode {
    /** 横向流。 */
    ROW,

    /** 纵向流。 */
    COLUMN,

    /** 层叠:子节点默认 absolute(0,0),可通过显式 x/y 偏移。由 DSL `stack {}` 触发。 */
    STACK,

    /** 网格布局。 */
    GRID,

    /**
     * 绝对定位画布:子节点自动 absolute 但不补默认坐标,保留用户原始 x/y(含 auto)。
     * 由 DSL `box { layout = "absolute" }` 触发。Taffy 表现同 Flex+ROW,实际靠子 absolute 绕开。
     */
    ABSOLUTE
}
